import {gsap} from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

const PinchZoom = {
    minZoom: 1,
    maxZoom: 3,
    currScale: 1,
    lastScale: 1,
    start: {},

    init(img) {
        this.img = img;
        if (!this.img.length) return;
        this.scroller = this.img.closest('.scroller');
        this.bind();
    },

    bind() {
        this.img[0].addEventListener('touchstart', (evt) => {
            if (evt.touches.length === 2) {
                evt.preventDefault();
                this.touch(evt);
            }
        });

        this.img[0].addEventListener('touchmove', (evt) => {
            if (evt.touches.length === 2) {
                evt.preventDefault();
                this.zoom(evt);
            }
        });

        this.img[0].addEventListener('touchend', (evt) => {
            evt.preventDefault();
            this.lastScale = this.currScale;
        });

        // fot test on iphone

        // this.img[0].addEventListener('dblclick', (evt) => {
        //     evt.preventDefault();
        //     this.zoomTo(evt, 2);
        // });
        //
        // document.addEventListener('keydown', evt => {
        //     if (evt.key === 'Escape') {
        //         this.zoomOut();
        //     }
        // });
        //
        // let tapedTwice = false;
        //
        // this.img[0].addEventListener('touchstart', (evt) => {
        //     if (!tapedTwice) {
        //         tapedTwice = true;
        //         setTimeout(function () {
        //             tapedTwice = false;
        //         }, 300);
        //         return false;
        //     }
        //     event.preventDefault();
        //     this.zoomTo(evt, 2);
        //
        // })

    },

    zoomTo(evt, scale) {
        if(this.isScaled){
            this.zoomOut();
            this.isScaled = false;
        } else {
            this.zoomIn(evt, scale);
            this.isScaled = true;
        }
    },

    zoomIn(evt, scale) {
        const X = evt.touches ? evt.touches[0].pageX : evt.pageX;
        const Y = evt.touches ? evt.touches[0].pageY : evt.pageY;

        const sLeft = this.scroller.scrollLeft();
        const sTop = this.scroller.scrollTop();
        const imgRect = this.img[0].getBoundingClientRect();

        let factorX = (X + sLeft) / imgRect.width;
        let factorY = (Y + sTop) / imgRect.height;

        const maxLeft = ((this.img.outerWidth() * scale) - window.innerWidth)
        const maxTop = ((this.img.outerHeight() * scale) - window.innerHeight)

        const deltaX = (maxLeft * factorX);
        const deltaY = (maxTop * factorY);

        gsap.to(this.img, {scale: scale});
        gsap.to(this.scroller, {scrollTo: {x: deltaX, y: deltaY}});
    },

    zoomOut() {
        const deltaX = (this.img.outerWidth() - window.innerWidth) / 2;
        const deltaY = (this.img.outerHeight() - window.innerHeight) / 2;
        gsap.to(this.img, {scale: 1});
        gsap.to(this.scroller, {scrollTo: {x: deltaX, y: deltaY}});
    },

    touch(evt) {
        this.start.distance = this.getDistance(evt);
        this.start.deltaX = this.scroller.scrollLeft();
        this.start.deltaY = this.scroller.scrollTop();
        this.start.x = Math.max(evt.touches[0].pageX, evt.touches[1].pageX);
        this.start.y = Math.max(evt.touches[0].pageY, evt.touches[1].pageY);
        this.start.imgWidth = this.img[0].getBoundingClientRect().width;
        this.start.imgHeight = this.img[0].getBoundingClientRect().height;
    },

    zoom(evt) {
        let scale;
        if (evt.scale) {
            // Safari only
            scale = evt.scale;
        } else {
            const deltaDistance = this.getDistance(evt);
            scale = deltaDistance / this.start.distance;
        }

        if (scale > 1) scale += this.lastScale - 1;
        else scale -= 1 - this.lastScale

        this.currScale = Math.min(Math.max(this.minZoom, scale), this.maxZoom);
        this.img.css({transform: 'scale(' + this.currScale + ')'});

        this.scroll(evt);
    },

    scroll(evt) {
        let factorX = (this.start.x + this.start.deltaX) / this.start.imgWidth * 2;
        let factorY = (this.start.y + this.start.deltaY) / this.start.imgHeight * 2;

        const deltaX = this.start.deltaX + (this.img.outerWidth() * (this.currScale - this.lastScale) / 2 * factorX);
        const deltaY = this.start.deltaY + (this.img.outerHeight() * (this.currScale - this.lastScale) / 2 * factorY);

        this.scroller.scrollLeft(deltaX).scrollTop(deltaY);
    },

    getDistance(evt) {
        return Math.hypot(evt.touches[0].pageX - evt.touches[1].pageX, evt.touches[0].pageY - evt.touches[1].pageY);
    },

    destroy() {
        this.img.parent().remove();
        this.currScale = 1;
        this.lastScale = 1;
        this.start = {};
    },
}

export default PinchZoom;